import React, { Component } from "react";
import PropTypes from "prop-types";
import { modalType } from "../../../../../helpers/dotenv";
import RegionAddEdit from "./RegionAddEdit";
import { Wrapper } from "modules/theme";
import SettingsSidebar from "../../sidebar";
import { Alert, confirm } from "modules/theme";
import APIManager from "modules/common/apiManager";
import withTableWrapper from "modules/common/components/table/withTableWrapper";
import { FiTrash2 } from "react-icons/fi";
import { PerPage } from "helpers/system-config";
import {
  ModalTrigger,
  Button,
  FormControl,
  ActionButtons,
  Table,
  Tip,
  DataWithLoader,
  ReportPagination,
  ControlLabel,
  SeachForm,
  Icon,
  DataWrapperClass,
  SettingDropdownMenu,
  ButtonCommonTheme,
} from "modules/theme";
import { CustomDropdown } from "modules/common/components";
import { leftSidebarType } from "../../../../../helpers/dotenv";
import { BackButton, CenterFlexRow } from "../../styles";
import { Link } from "react-router-dom";
import { MenuItem } from "react-bootstrap";
export class Region extends Component {
  constructor(props) {
    super(props);
    this.moduleName = `Region`;
    this.moduleUrl = `region`;
    this.mAPI = new APIManager();
    this.getList = this.getList.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onPerPageChooser = this.onPerPageChooser.bind(this);
    this.state = {
      listData: [],
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      loading: false,
      editData: null,
      showHide: false,
      modalType: modalType,
      search: "",
      MasterChecked: false,
      SingleChecked: false,
      SelectedList: [],
      ary: [],
      searchValue: "",
    };
  }

  onMasterCheck(e) {
    let tempList = this.state.listData;
    // Check/ UnCheck All Items
    tempList.map((listData) => (listData.selected = e.target.checked));
    //Update State
    this.setState({
      MasterChecked: e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  onItemCheck(e, item) {
    let tempList = this.state.listData;
    tempList.map((user) => {
      if (user._id === item._id) {
        user.selected = e.target.checked;
      }
      return user;
    });
    //To Control Master Checkbox State
    const totalItems = this.state.listData.length;
    const totalCheckedItems = tempList.filter((e) => e.selected).length;
    // Update State
    this.setState({
      MasterChecked: totalItems === totalCheckedItems && e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  search(e) {
    const value = e.target.value;
    const reg = /^[a-zA-Z0-9_ @]*$/;
    if (reg.test(value)) {
      if (value.trim() || value === "") {
        let teamList = this.state.listData.map((item) => ({
          ...item,
          selected: false,
        }));
        this.setState({
          SelectedList: [],
          MasterChecked: false,
          SingleChecked: false,
          listData: teamList,
          searchValue: value,
          currentPage: 1
        });
        if (this.timer) clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.setState({ search: value });
          this.getList(1, this.state.perPageCount, value);
        }, 500);
      }
    }
  }
  componentDidMount() {
    this.getList(
      this.state.currentPage,
      this.state.perPageCount,
      this.state.search
    );
  }
  onPaginationChange(page) {
    this.setState({ currentPage: page });
    this.getList(page, "", this.state.search);
  }
  onPerPageChooser(perPage) {
    this.setState({ currentPage: 1 });
    this.setState({ perPageCount: perPage });
    this.getList(1, perPage, this.state.search);
  }

  closeModal(isUpdated) {
    console.log("isUpdated", isUpdated);
    this.setState({ showHide: false });
    if (isUpdated) {
      this.getList(
        this.state.currentPage,
        this.state.perPageCount,
        this.state.search
      );
    }
  }
  openModal(data) {
    console.log("openmodal being run");
    if (data) {
      this.setState({ showHide: true, editData: data });
    } else {
      this.setState({ showHide: true, editData: undefined });
    }
  }

  getList(page = 1, perPage = "", searchText = "") {
    var that = this;
    this.setState({ loading: true });
    perPage = perPage || this.state.perPageCount;
    this.mAPI.sendGetAPI(
      `${this.moduleUrl}?limit=${perPage}&page_no=${page}&search=${searchText}&orderBy=create_at&order=DESC`,
      (data) => {
        this.setState({ loading: false });
        console.log(JSON.stringify(data, null, 2));
        if (data && data.data) {
          that.setState({
            listData: data.data,
            total: data.count || 0,
            SelectedList: [],
          });
        }
      },
      (error, data) => {
        this.setState({ loading: false, listData: [], total: 0 });
        if (data) {
          Alert.error(` ${data.message}`);
        } else {
          Alert.error(`${error}`);
        }
      },
      "public"
    );
  }

  remove(array, key, value) {
    const index = array.findIndex((obj) => obj[key] === value);
    return index >= 0
      ? [...array.slice(0, index), ...array.slice(index + 1)]
      : array;
  }

  deleteAllData(e) {
    let _this = this;
    e.preventDefault();
    const list = this.state.SelectedList.map((data) => {
      this.state.ary.push(data._id);
    });
    this.mAPI.sendPostAPI(
      `setting/break/multiple/usingIds`,
      {
        ids: this.state.ary,
      },
      (data) => {
        this.setState({ currentPage: 1, MasterChecked: false });
        this.getBreak(
          this.state.currentPage,
          this.state.perPageCount,
          this.state.search
        );
        Alert.success(
          `${this.moduleName}${
            data.modifiedCount > 1 ? "s" : ""
          } deleted successfully.`
        );
      },
      (errorCode, data) => {
        Alert.error(`errorCode : ${data}`);
      },
      `private`,
      {},
      "PUT"
    );
  }

  deleteData(data) {
    var that = this;
    this.mAPI.sendPostAPI(
      `${this.moduleUrl}/${data._id}`,
      undefined,
      (data) => {
        console.log(JSON.stringify(data, null, 2));
        let tD = that.state.listData;
        tD = that.remove(tD, "_id", data._id);
        that.setState({ listData: tD });
        this.getList(
          this.state.currentPage,
          this.state.perPageCount,
          this.state.search
        );
        Alert.success(`${this.moduleName} deleted successfully.`);
      },
      (errorCode, data) => {
        console.log(`Error: `, errorCode);
        console.log(`Data`, data);
        Alert.error(`errorCode : ${data.message}`);
      },
      "public",
      {},
      "DELETE"
    );
  }

  edit(data) {
    return (
      <ButtonCommonTheme type="edit" editOnClick={() => this.openModal(data)} />
    );
  }

  renderActions(data, index) {
    return (
      <ActionButtons>
        {this.edit(data)}
        <CustomDropdown
          index={index}
          totalLength={this.state.listData.length || 0}
        >
          <MenuItem
            onClick={(e) =>
              confirm("Are you sure?", {
                url: "/images/icons/ic_delete_main.svg",
                isDeleted: true,
              }).then((e) => {
                this.deleteData(data, e);
              })
            }
          >
            Delete
          </MenuItem>
        </CustomDropdown>
      </ActionButtons>
    );
  }

  renderActionBar() {
    const ImportTrigger = ({ onClick }) => {
      return <ButtonCommonTheme type="add" addOnClick={onClick} />;
    };
    return (
      <span style={{ display: "flex", whiteSpace: "nowrap" }}>
        <ModalTrigger
          title={this.moduleName}
          trigger={<ImportTrigger />}
          size="md"
          showHide={this.state.showHide}
          closeModal={this.closeModal}
          openModal={this.openModal}
          dialogClassName={this.state.modalType}
        >
          <RegionAddEdit
            update={() => this.setState({ currentPage: 1 })}
            size="small"
            isEdit={false}
            soundList={this.state.soundList}
            editData={this.state.editData}
            modalType={this.state.modalType}
            closeModal={this.closeModal}
          />
        </ModalTrigger>
      </span>
    );
  }

  render() {
    const { __ } = this.context;
    const breadcrumb = [
      { title: __("Settings"), link: "/settings" },
      { title: __("Region"), link: "/settings/region" },
    ];

    const mainContent = (
      <DataWrapperClass overflow="nohide" className="tableFixHeadSecondary">
        <Table whiteSpace="nowrap" bordered hover>
          <thead>
            <tr>
              <th>{__("Region Name")}</th>
              <th>{__("Actions")}</th>
            </tr>
          </thead>
          <tbody>
            {this.state.listData.map((data, index) => (
              <tr key={data._id}>
                <td>{data.region_name}</td>
                <td>{this.renderActions(data, index)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </DataWrapperClass>
    );

    return (
      <DataWrapperClass>
        {/* <MiddleContent> */}
        <Wrapper
          header={<Wrapper.Header breadcrumb={breadcrumb} />}
          heading={
            <CenterFlexRow className="header-label">
              <Link className="btn-back" to={`/settings`}>
                <BackButton>
                  <Icon icon="angle-left" size={20} />
                </BackButton>
              </Link>
              <ControlLabel>{`Region`}</ControlLabel>
            </CenterFlexRow>
          }
          actionBar={
            <Wrapper.ActionBar
              left={
                <div style={{ display: "flex" }}>
                  <SeachForm className="mr-5">
                    <FormControl
                      type="text"
                      placeholder={"Search Here"}
                      onChange={(e) => this.search(e)}
                      value={this.state.searchValue}
                      autoFocus={false}
                    />
                    <span class="material-symbols-outlined">search</span>
                  </SeachForm>
                </div>
              }
              // right={actionBarRight}
              right={this.renderActionBar()}
            />
          }
          footer={
            <ReportPagination
              count={this.state.total}
              onPaginationChange={this.onPaginationChange}
              onPerPageChooser={this.onPerPageChooser}
              currentPage={this.state.currentPage}
              perPage={this.state.perPageCount}
            />
          }
          leftSidebar={<SettingDropdownMenu />}
          showLeftSideBar={true}
          content={
            <div>
              <DataWithLoader
                data={mainContent}
                loading={this.state.loading}
                size={this.state.listData.length}
                count={this.state.listData.length}
                emptyText={`Sorry..! No ${this.moduleName} Found`}
                emptyImage="/images/emptyimg.png"
              />
            </div>
          }
        />
        {/* </MiddleContent> */}
      </DataWrapperClass>
    );
  }
}

Region.contextTypes = {
  __: PropTypes.func,
};

export default Region;



// WEBPACK FOOTER //
// src/modules/screens/settings/Region/components/Region.js